<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title> Filtros </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span> Reactivaciones </span>
              <v-autocomplete
                v-model="form.reactivations"
                :items="reactivations"
                label="Seleccione contenido de reactivación"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span> Estatus preservada</span>
              <v-autocomplete
                v-model="form.status"
                :items="status"
                label="Seleccione estatus"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span> Estatus reactivación</span>
              <v-autocomplete
                v-model="form.statusReactivation"
                :items="statusReactivation"
                label="Seleccione estatus"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Ordenamiento</span>
              <v-autocomplete
                v-model="form.sort"
                :items="sorts"
                label="Seleccione ordenamiento"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="gray" dark @click="show = false" block>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="info" @click="cleanFilters" block>
                Limpiar filtros
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="primary" @click="applyFilters" block>
                Aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    form: {
      status: null,
      reactivations: null,
      statusReactivation: null,
      sort: "1",
    },
    reactivations: [
      {
        text: "Con reactivaciones",
        value: true,
      },
      {
        text: "Sin reactivaciones",
        value: false,
      },
    ],
    status: [
      {
        text: "No disponible",
        value: "DISABLED",
      },
      {
        text: "En uso",
        value: "USING",
      },
    ],
    statusReactivation: [
      {
        text: "Reactivada",
        value: "REACTIVATING",
      },
      {
        text: "Entregada",
        value: "DELIVERED",
      },
      {
        text: "En producción",
        value: "PRODUCTION",
      },
      {
        text: "Contaminada",
        value: "CONTAMINATED",
      },
    ],

    sorts: [
      {
        text: "Más reciente",
        value: "-1",
      },
      {
        text: "Menos reciente",
        value: "1",
      },
    ],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    cleanFilters() {
      this.form = {
        status: null,
        reactivations: null,
        statusReactivation: null,
        sort: "1",
      };
      this.$emit("filter", this.form);
      this.show = false;
    },
    applyFilters() {
      this.$emit("filter", this.form);
      this.show = false;
    },
  },
};
</script>
